import { Routes, Route } from "react-router-dom";
import HomeCustomer from "./HomeCustomer"; // navbar + <Outlet />
import OrderForm from "./OrderForm";
import ManageOrders from "./OrderList";
import EditOrderForm from "./UpdateOrder1";
import OrderDetails from "./OrderView";
import TrackOrder from "./TrackOrder";
import PaymentHistory from "./PaymentList";
import NotFound from "../pages/NotFound";
import Profile from './UpdateProfile'

const CustomerRoutes = () => {
  return (
    <Routes>
    <Route path="/" element={<HomeCustomer />}>
      <Route index element={<h1>Customer Dashboard</h1>} />
      <Route path="make" element={<OrderForm />} />
      <Route path="ManageOrder" element={<ManageOrders />} />
      <Route path="profile" element={<Profile />} />
      <Route path="edit/:orderId" element={<EditOrderForm />} />
      <Route path="view/:id" element={<OrderDetails />} />
      {/* <Route path="viewOrder/:id" element={<OrderDetails />} /> */}
      <Route path="track" element={<TrackOrder />} />
      <Route path="paymentHistory" element={<PaymentHistory />} />
    </Route>
    
    {/* Catch-all for customer routes */}
    <Route path="*" element={<NotFound />} />
  </Routes>
  );
};

export default CustomerRoutes;
